import { render, staticRenderFns } from "./FictitiousList.vue?vue&type=template&id=d6a2d546"
import script from "./FictitiousList.vue?vue&type=script&lang=js"
export * from "./FictitiousList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports